import { type Updater, type VisibilityState } from "@tanstack/react-table";
import { useLocalStorage } from "react-use";

export function useTableColumnVisibility(tableId: string) {
  const [columnVisibility, setColumnVisibility] = useLocalStorage<VisibilityState>(`table-visibility-${tableId}`, {});

  const onColumnVisibilityChange = (updater: Updater<VisibilityState>) => {
    const updatedVisibility = typeof updater === "function" ? updater(columnVisibility || {}) : updater;
    setColumnVisibility(updatedVisibility);
  };

  return {
    columnVisibility,
    onColumnVisibilityChange,
  };
}
